import { createReducer, on } from '@ngrx/store';
import * as fromAuthActions from '../actions/auth.actions';
import * as fromOrganizationActions from '../actions/organization.actions';

export const featureKey = 'organization';

export interface State {
    passes: any,
    organization: any;
    userOrganization: any;
    userOrganizationPoints: any;
    activeOrganization: any;
    recentJoinedOrg: any;
    activeSendee: any;
    organizationContent: {
      data: Array<any>,
      isLoaded: Boolean
    },
    pendingFeedback: {
      data: Array<any>,
      isLoaded: Boolean
    },
    appointmentLocation: {
      data: Array<any>,
      isLoaded: Boolean
    },
}

export const initialState: State = {
  passes: {
    data: {
      activePasses: [],
      expiredPasses: []
    },
    isLoaded: false
  },
  organization: [],
  userOrganization: [],
  activeSendee: {
    data: null,
    isLoaded: false
  },
  userOrganizationPoints: {
    isLoaded: false,
    getPoints: 0,
    orgPoints: 0,
    organizationList: []
  },
  activeOrganization: null,
  recentJoinedOrg: null,
  organizationContent: {
    data: [],
    isLoaded: false
  },
  pendingFeedback: {
    data: [],
    isLoaded: false
  },
  appointmentLocation: {
    data: [],
    isLoaded: false
  },
};

export const reducer = createReducer(
    initialState,
    on(fromOrganizationActions.getUserPassesSuccess, (state: State, props: any) => ({
        ...state,
        passes: {data: props.data, isLoaded: true}
    })),
    on(fromOrganizationActions.setUserPassesLoader, (state: State, props: any) => ({
        ...state,
        passes: { ...state.passes, isLoaded: props.status }
    })),
    on(fromOrganizationActions.getOrganizationSuccess, (state: State, props: any) => ({
      ...state,
      organization: props.data,
    })),
    on(fromOrganizationActions.getUserOrganizationSuccess, (state: State, props: any) => ({
      ...state,
      userOrganization: props.data,
    })),
    on(fromOrganizationActions.getUserOrganizationPointsSuccess, (state: State, props: any) => ({
      ...state,
      userOrganizationPoints: {...props.data, isLoaded: true}
    })),
    on(fromOrganizationActions.getUserOrganizationPointsFailed, (state: State, props: any) => ({
      ...state,
      userOrganizationPoints: {...state.userOrganizationPoints, isLoaded: true}
    })),
    on(fromOrganizationActions.joinOrganizationSuccess, (state: State, props: any) => ({
      ...state,
      recentJoinedOrg: props.org
    })),
    on(fromOrganizationActions.setActiveORganizationSuccess, (state: State, props: any) => ({
      ...state,
      activeOrganization: props.organization
    })),
    on(fromOrganizationActions.getOrganizationContentSuccess, (state: State, props: any) => ({
      ...state,
      organizationContent: {data: props.data, isLoaded: true}
    })),
    on(fromOrganizationActions.getUserFeedbackSuccess, (state: State, props: any) => ({
      ...state,
      pendingFeedback: {data: props.data, isLoaded: true}
    })),
    on(fromOrganizationActions.setActiveSendee, (state : State, props : any) => ({
      ...state,
      activeSendee: {data : props.data, isLoaded : true}
    })),
    on(fromOrganizationActions.getAppointmentLocationSuccess, (state: State, props: any) => ({
      ...state,
      appointmentLocation: {data: props.data, isLoaded: true}
    })),
    on(fromAuthActions.autoLogout, (state: State, props) => initialState)
);
